/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbPcs_user$ref = any;
export type PdpSharedBlurbPcs_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly isVip: boolean | null;
    readonly " $refType": PdpSharedBlurbPcs_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbPcs_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVip",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '67739f58f2c2fce90a6e4094ea238ae4';
export default node;
